import axios from 'axios';

export function getStudentClassrooms(id) {
  return axios.get(`/api/students/${id}/classrooms`);
}

export function getStudentById(id) {
  return axios.get(`/api/students/${id}`);
}

export function getStudentBySlug(slug) {
  return axios.get(`/api/students/user/${slug}`);
}

export function updateStudentData(id, data) {
  return axios.post(`/api/students/${id}`, data);
}

export function getStudentMasterclasses(slug) {
  return axios.get(`/api/students/${slug}/masterclasses`);
}

export function getStudentPaymentMethods(id, type) {
  return axios.get(`/api/students/${id}/payment-methods?type=${type}`);
}

export function getStudentSchools(userId) {
  return axios.get(`/api/students/${userId}/schools`);
}

export function getStudentInstruments(id) {
  return axios.get(`/api/students/${id}/instruments`);
}
